<template>
    <a :href="linkUrl || '#'" @click="onSelect()"
        class="flex items-center p-3 rounded transition-all duration-200 ease-out font-medium"
        :class="{
            'text-white bg-gray-800': isActive,
            'text-gray-500': !isActive,
            'cursor-pointer hover:text-white hover:bg-gray-800': isClickable,
            'cursor-default': !isClickable,
        }"
    >
        <div class="w-8">
            <i v-if="icon" :class="icon" />
        </div>
        <span class="ds-text-xs whitespace-no-wrap">{{name}}</span>
    </a>
</template>

<script>
export default {
    props: {
        name: { type: String, required: true },
        icon: { type: String },
        isActive: { type: Boolean, default: false },
        linkUrl: { type: String, required: false },
    },

    computed: {
        isClickable() {
            return !!(this.linkUrl || this.$listeners.click)
        }
    },

    methods: {
        onSelect() {
            this.$emit('click')
        }
    }
}
</script>